<script lang="ts">
	import type { InventoryType } from 'utility/search-fields'

	import { onMount, type ComponentProps } from 'svelte'
	import { loadInventoryTypes } from 'utility/search-fields'
	import Autocomplete from '@isoftdata/svelte-autocomplete'
	import type { i18n } from 'types/common'
	import { getContext } from 'svelte'
	const { t: translate } = getContext<i18n>('i18next')

	interface Props extends Omit<
		ComponentProps<typeof Autocomplete<InventoryType | null>>,
		'value' | 'options' | 'getLabel'
	> {
		inventoryTypeList?: InventoryType[]
		inventoryType?: InventoryType | null
		initialValue?: number
		vehicle?: boolean | undefined //Defines if the loaded list of inventory types should be filtered to just vehicle types
	}

	let {
		inventoryTypeList = $bindable([]),
		inventoryType = $bindable(null),
		initialValue,
		vehicle = undefined,

		...rest
	}: Props = $props()

	onMount(async () => {
		inventoryTypeList = await loadInventoryTypes({ vehicle })
		if (initialValue) {
			inventoryType = inventoryTypeList.find(inventoryType => inventoryType.id === initialValue) ?? null
		}
	})
</script>

<Autocomplete
	{...rest}
	label={vehicle ? translate('search.unitType', 'Unit Type') : translate('common:inventoryType', 'Inventory Type')}
	placeholder={`-- ${vehicle ? translate('search.selectAUnitType', 'Select a Unit Type') : translate('search.selectAnInventoryType', 'Select an Inventory Type')} --`}
	options={inventoryTypeList}
	emptyValue={null}
	bind:value={inventoryType}
	getLabel={option => (option ? `${option?.id} - ${option?.name}` : '')}
></Autocomplete>
